import request from '@/utils/request';

// 每周导入 xlsx(微信添加/签约/引流/试课)
export function importWeekly(formData) {
  return request({
    url: '/sys/cityDailyData/importWeekly',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}

// 月度汇总导出(最多6周) - 与现有 日报导出 机制一致, 服务端写 OSS 后前端在下载中心获取
export function monthSummaryExport(query) {
  return request({
    url: '/sys/cityDailyData/monthSummaryExport',
    method: 'post',
    params: query,
    responseType: 'arraybuffer'
  });
}

// 月汇总预览(网页查看, 与导出口径一致): 按城市分组 + 城市小计, 前端做展示层美化
export function monthSummaryView(query) {
  return request({
    url: '/sys/cityDailyData/monthSummaryView',
    method: 'post',
    params: query
  });
}

// 导入批次历史: 回看每周谁导入(按归属月过滤, 可空=全部); deptCoverage 为 JSON 字符串需前端 parse
export function importHistory(params) {
  return request({
    url: '/sys/cityDailyData/importHistory',
    method: 'post',
    params
  });
}

// 城市清单(area.type=2, 含加盟/代运营变体), 供城市多选下拉(保留, 但页面优先用 importedCityList)
export function cityList() {
  return request({
    url: '/sys/cityDailyData/cityList',
    method: 'post'
  });
}

// 当月已导入城市清单: 只返回该月有数据的城市, 避免下拉出现未导入城市
export function importedCityList(params) {
  return request({
    url: '/sys/cityDailyData/importedCityList',
    method: 'post',
    params
  });
}

// 城市维度日明细: 月+周多选(空=全月)+城市多选(空=全部)
export function dayDetail(params) {
  return request({
    url: '/sys/cityDailyData/dayDetail',
    method: 'post',
    params
  });
}
